/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderBigTablePageResVo } from './OrderBigTablePageResVo';
import {
    OrderBigTablePageResVoFromJSON,
    OrderBigTablePageResVoFromJSONTyped,
    OrderBigTablePageResVoToJSON,
    OrderBigTablePageResVoToJSONTyped,
} from './OrderBigTablePageResVo';

/**
 * 
 * @export
 * @interface PageDataOrderBigTablePageResVo
 */
export interface PageDataOrderBigTablePageResVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataOrderBigTablePageResVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataOrderBigTablePageResVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataOrderBigTablePageResVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<OrderBigTablePageResVo>}
     * @memberof PageDataOrderBigTablePageResVo
     */
    records?: Array<OrderBigTablePageResVo>;
}

/**
 * Check if a given object implements the PageDataOrderBigTablePageResVo interface.
 */
export function instanceOfPageDataOrderBigTablePageResVo(value: object): value is PageDataOrderBigTablePageResVo {
    return true;
}

export function PageDataOrderBigTablePageResVoFromJSON(json: any): PageDataOrderBigTablePageResVo {
    return PageDataOrderBigTablePageResVoFromJSONTyped(json, false);
}

export function PageDataOrderBigTablePageResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataOrderBigTablePageResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(OrderBigTablePageResVoFromJSON)),
    };
}

export function PageDataOrderBigTablePageResVoToJSON(json: any): PageDataOrderBigTablePageResVo {
    return PageDataOrderBigTablePageResVoToJSONTyped(json, false);
}

export function PageDataOrderBigTablePageResVoToJSONTyped(value?: PageDataOrderBigTablePageResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(OrderBigTablePageResVoToJSON)),
    };
}

